import { render, staticRenderFns } from "./Arbitration.vue?vue&type=template&id=779f332a"
import script from "./Arbitration.vue?vue&type=script&lang=js"
export * from "./Arbitration.vue?vue&type=script&lang=js"
import style0 from "./Arbitration.vue?vue&type=style&index=0&id=779f332a&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports